var map = {
	"./apps/ai/featureSelection/featureSelection.saga.js": 839,
	"./apps/ai/manager/userPrompt/userPrompt.saga.js": 555,
	"./apps/ai/preferences/preferences.saga.js": 840,
	"./apps/combinedContextLoader/combinedContextLoader.saga.js": 841,
	"./apps/dashboard/actionlist/actionlist.saga.js": 842,
	"./apps/projectManagement/addProjectModal/addProjectModal.saga.js": 556,
	"./apps/projectManagement/projectConfig/projectConfig.saga.js": 843,
	"./apps/workflow/headingWorkflow/headingWorkflow.saga.js": 844,
	"./apps/workflow/schemaBasedEditor/schemaBasedEditor.saga.js": 845,
	"./apps/workflow/workflowEditor/document/documentWorkflowEditor.saga.js": 846,
	"./apps/workflow/workflowEditor/heading/headingWorkflowEditor.saga.js": 847,
	"./apps/workflow/workflowWidget/components/approvalHistoryModal/approvalHistoryModal.saga.js": 848,
	"./apps/workflow/workflowWidget/workflowWidget.saga.js": 557,
	"./contexts/account/account.saga.js": 849,
	"./contexts/document/document.saga.js": 850,
	"./contexts/heading/heading.saga.js": 851,
	"./contexts/instance/instance.saga.js": 852,
	"./contexts/organisation/organisation.saga.js": 853,
	"./contexts/project/dataTypes/groups/groups.saga.js": 854,
	"./contexts/project/dataTypes/users/users.saga.js": 558,
	"./contexts/project/project.saga.js": 855,
	"./contexts/workflowinstance/workflowinstance.saga.js": 856,
	"./globals/dataTypes/auth/auth.saga.js": 559,
	"./globals/dataTypes/comments/comments.saga.js": 857,
	"./globals/dataTypes/login/login.saga.js": 239,
	"./globals/dataTypes/maintenance/data/data.saga.js": 858,
	"./globals/dataTypes/notificationSettings/notificationSettings.saga.js": 560,
	"./globals/dataTypes/notifications/notifications.saga.js": 561,
	"./globals/dataTypes/performanceLogs/performanceLogs.saga.js": 859,
	"./globals/dataTypes/projects/projects.saga.js": 562,
	"./globals/dataTypes/sysconfig/sysconfig.saga.js": 860,
	"./globals/dataTypes/workflow/workflowEditor/workflowEditor.saga.js": 861,
	"./globals/dataTypes/workflow/workflowTasks/workflowTasks.saga.js": 563,
	"./globals/global.saga.js": 564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 525;